/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * })); 
 */
document.addEventListener('drawer:toggle', function(event) {
    document.querySelector("#shopify-section-header").classList.toggle('is-open', event.detail.open);
    document.querySelector(".hamburger[data-drawer-id='sidebar-menu']").classList.toggle("is-active", event.detail.open);

    
});



  document.addEventListener('theme:loading:end', function(event) {
        setTimeout(
            function() {
                var count = 0;
                var inputs = document.querySelectorAll("#sidebar-cart .QuantitySelector__CurrentQuantity");
                for (var i = 0 ; i<inputs.length; i++) {
                    count = count + Number(inputs[i].value);
                }
                document.querySelector("header .cart-count").innerText = count;
            }, 1000);
});

window.addEventListener('DOMContentLoaded', (event) => {
    console.log('DOM fully loaded and parsed');  
    if (document.getElementById("success-customer_posted")) {
        document.getElementById("success-customer_posted").scrollIntoView()
    }
});